import Amount from "./amount";
import PaymentMethods from "./methods";

const PaymentContent = ({ data, paymentMethod, onChangeMethods }) => {
  return (
    <div className="p-5">
      <Amount data={data} />
      <PaymentMethods
        data={data}
        paymentMethod={paymentMethod}
        onChangeMethods={onChangeMethods}
      />
    </div>
  );
};
export default PaymentContent;
